import styled from "styled-components";
import {useEffect, useState} from "react";

export default function SelectProject({close}: { close: () => void }) {

    const [projects, setProjects] = useState<any[]>([])

    useEffect(() => {
        let allProj = localStorage.getItem('all_projects') as any;
        if (allProj === null)
            window.location.href = '/login.html'
        setProjects(JSON.parse(allProj).filter((p: { new: boolean; }) => p.new))
    }, []);

    const changeProj = (newProj: any) => {
        localStorage.setItem('project', JSON.stringify(newProj))
        window.location.reload()
    }


    return <Container onClick={(e) => e.stopPropagation()}>
        <h3 className="header">Змінити проект</h3>
        <div className="main">
            {projects.map(p => <button key={p.actId} className="projectInfo" onClick={() => changeProj(p)}>
                <span className="projectName">{p.actName}</span>
                <span className="projectPeriod">{p.actStart} - {p.actEnd || '&'}<span
                    className={`projectStatus ${p.new ? 'active' : 'inactive'}`}></span></span>
            </button>)}
        </div>
        <div className="controls">
            <button onClick={close}>
                ❌
            </button>
        </div>
    </Container>
}

const Container = styled.section`
    max-width: min(500px, 85vw);
    max-height: 80vh;
    width: 100%;
    color: var(--table-row-text-color);
    padding: .5rem;
    border-radius: .5rem;
    background-color: var(--table-row-odd-bg-color);

    display: flex;
    gap: .5rem;
    flex-flow: column;

    & .header {
        font-size: 1.1rem;
        font-weight: bold;
        text-align: center;
    }

    .main {
        display: flex;
        flex-flow: column;
        gap: .5rem;
    }

    .projectInfo {
        background: linear-gradient(135deg, rgba(149, 231, 255, 0.87), rgba(255, 255, 255, 1));
        display: flex;
        flex-flow: column;
        align-items: center;
        gap: .5rem;
        justify-content: space-between;
        width: 100%;
    }

    .projectName {
        font-weight: bold;
        font-size: 16px;
    }

    .projectPeriod {
        font-size: 14px;
        color: #555;
        display: flex;
        gap: .5rem;
        align-items: center;
    }

    .projectStatus {
        min-width: 12px;
        height: 12px;
        flex-shrink: 0;
        border-radius: 50%;
        flex-shrink: 0;
    }

    .projectStatus.active {
        background-color: #4caf50; /* Green */
    }

    .projectStatus.inactive {
        background-color: #ccc; /* Gray */
    }

    & .controls {
        display: flex;
        justify-content: end;
        align-items: center;

        & button {
            background: var(--table-action-color);
            padding: .2rem;
            cursor: pointer;
            border-radius: .2rem;
            display: flex;
            vertical-align: center;
            align-items: center;
            justify-content: center;
            font-size: 1rem;
            border: none;

            &:hover {
                filter: brightness(.85);
            }
        }
    }

`
